import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { setNavigate } from "../services/navigation";

export default function Layout() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return <>
    <Outlet />
  </>;
}
